import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Coffee Brewing',
        content: 'Freshly brewed coffee crafted with premium beans and expert techniques to deliver an exceptional coffee experience.',
        paragraphs: [
            'At our coffee shop, we pride ourselves on offering freshly brewed coffee made with premium beans. Our expert baristas use the finest techniques to brew the perfect cup of coffee, whether it\'s a rich espresso, a smooth latte, or a frothy cappuccino. Every cup is crafted with care to deliver a truly exceptional coffee experience.',
            'We use a variety of brewing methods, including pour-over, French press, and espresso machines, to bring out the best flavors in each blend. Whether you\'re a seasoned coffee enthusiast or new to the world of coffee, our coffee brewing services are sure to satisfy your taste buds.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Freshly Brewed Coffee Daily',
            'High-Quality Beans Sourced from Local Roasters',
            'Expert Baristas with Craft Coffee Expertise',
            'Variety of Brewing Methods: Espresso, Pour-Over, French Press',
            'Customizable Coffee Drinks to Suit Your Preferences'
        ],
        procedure: [
            'Selection of Premium Coffee Beans',
            'Grinding Beans to Perfection',
            'Brewing with Precision Using Expert Techniques',
            'Customizing to Your Taste Preferences',
            'Serving Fresh and Hot for a Perfect Coffee Experience'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What type of coffee beans do you use?',
                content: 'We use high-quality beans sourced from local roasters who specialize in craft coffee. We offer a variety of blends to suit different tastes and preferences, including dark roasts, light roasts, and everything in between.'
            },
            {
                id: 2,
                heading: 'Do you offer dairy-free milk options?',
                content: 'Yes! We offer a variety of dairy-free milk options, including oat milk, almond milk, and soy milk, so you can enjoy your coffee just the way you like it.'
            },
            {
                id: 3,
                heading: 'Can I customize my coffee?',
                content: 'Absolutely! We believe in creating the perfect cup of coffee for you. You can customize your coffee with different milk options, flavors, syrups, and even choose the strength of your coffee.'
            },
            {
                id: 4,
                heading: 'Do you serve cold brew coffee?',
                content: 'Yes, we serve refreshing cold brew coffee, made with the finest beans for a smooth and rich flavor. It\'s available in regular and flavored varieties.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Specialty Drinks',
        content: 'Enjoy a variety of seasonal and signature drinks crafted with unique flavors and fresh ingredients.',
        paragraphs: [
            'Our specialty drinks menu features a wide range of seasonal and signature creations designed to excite your taste buds. From fruity refreshers to indulgent dessert-inspired sips, each drink is thoughtfully crafted using high-quality ingredients.',
            'Whether you’re looking for something cool and energizing or warm and comforting, our specialty drinks offer a delicious break from the ordinary. Perfect for any season, our rotating specials ensure there’s always something new to try.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Seasonal Drink Menu Updates',
            'Signature Flavor Combinations',
            'Fresh, High-Quality Ingredients',
            'Customizable Sweetness and Toppings',
            'Options for Both Hot and Cold Drinks'
        ],
        procedure: [
            'Select a Seasonal or Signature Drink',
            'Customize Ingredients or Sweetness Level',
            'Prepared Fresh by Skilled Baristas',
            'Taste-Tested for Flavor Balance',
            'Served with Artistic Presentation'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Do specialty drinks change with the seasons?',
                content: 'Yes, we update our specialty drinks menu regularly to feature seasonal flavors and ingredients, keeping things fresh and exciting.'
            },
            {
                id: 2,
                heading: 'Can I customize a specialty drink?',
                content: 'Absolutely! You can adjust sweetness levels, swap out milk options, or even add extra flavor shots to personalize your drink.'
            },
            {
                id: 3,
                heading: 'Do you offer non-caffeinated specialty drinks?',
                content: 'Yes, we offer a selection of caffeine-free specialty drinks, including herbal teas, fruit refreshers, and creamy hot chocolates.'
            },
            {
                id: 4,
                heading: 'Are specialty drinks available all year?',
                content: 'While some signature drinks are available year-round, others rotate seasonally, so be sure to check out our current specials!'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Baked Goods',
        content: 'Freshly baked pastries and treats, perfect for pairing with your favorite coffee.',
        paragraphs: [
            "Our selection of baked goods is made fresh daily using quality ingredients. From buttery croissants to decadent brownies, our pastries are the perfect companion to your favorite cup of coffee.",
            "Whether you're craving something sweet or savory, our bakery case is always stocked with rotating classics and seasonal specialties. Each treat is crafted to offer the ideal texture and flavor for a satisfying bite."
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Freshly Baked Daily',
            'Wide Variety of Sweet and Savory Options',
            'Perfectly Paired with Coffee Drinks',
            'Gluten-Free and Vegan Options Available',
            'Locally Sourced Ingredients'
        ],
        procedure: [
            'Selection of High-Quality Ingredients',
            'Daily In-House Baking Process',
            'Quality Check for Freshness and Taste',
            'Arranged Fresh in the Display Each Morning',
            'Served with Optional Pairings and Add-Ons'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of baked goods do you offer?',
                content: 'We offer a variety including croissants, muffins, cookies, brownies, and seasonal specialties—all made fresh daily.'
            },
            {
                id: 2,
                heading: 'Do you have gluten-free or vegan options?',
                content: 'Yes! We provide a selection of gluten-free and vegan baked goods so everyone can enjoy a treat.'
            },
            {
                id: 3,
                heading: 'Are your baked goods made in-house?',
                content: 'Absolutely! All of our baked goods are prepared and baked in-house every day to ensure the freshest quality.'
            },
            {
                id: 4,
                heading: 'Can I pre-order baked goods for an event?',
                content: 'Yes, we accept pre-orders for large quantities or special occasions. Just contact us in advance to discuss your needs.'
            }
        ]
      },
      {
        id: 4,
        image: images.service4,
        title: 'Espresso Bar',
        content: 'A dedicated espresso bar with a variety of espresso-based drinks crafted by skilled baristas.',
        paragraphs: [
            'Our espresso bar is the heart of our café, where skilled baristas craft every shot with precision and care. Whether you prefer a bold espresso, a smooth latte, or a velvety cappuccino, we’ve got you covered.',
            'We use high-quality beans and expert techniques to bring out the best flavors in every cup. From traditional favorites to custom creations, our espresso bar delivers a premium coffee experience.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Expert Baristas Behind the Bar',
            'High-Quality Espresso Beans',
            'Wide Range of Espresso-Based Drinks',
            'Customizable Drink Options',
            'Consistent and Precise Extraction'
        ],
        procedure: [
            'Freshly Ground Espresso Beans',
            'Calibrating Machine for Optimal Shot',
            'Crafting Drinks to Customer Preferences',
            'Finishing Touches with Latte Art (Optional)',
            'Served Hot and Ready to Enjoy'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What espresso drinks do you offer?',
                content: 'We offer a full range of espresso-based drinks, including espresso, latte, cappuccino, macchiato, mocha, and more.'
            },
            {
                id: 2,
                heading: 'Can I customize my espresso drink?',
                content: 'Absolutely! You can customize with milk options, sweetness levels, flavors, and more.'
            },
            {
                id: 3,
                heading: 'Do you offer non-dairy milk options for espresso drinks?',
                content: 'Yes, we provide almond, oat, soy, and other non-dairy milk alternatives for all espresso-based beverages.'
            },
            {
                id: 4,
                heading: 'Are your baristas trained in latte art?',
                content: 'Yes! Our baristas are trained in latte art and love creating visually appealing drinks that taste just as good as they look.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Catering Services',
        content: 'Customized coffee and pastry catering for events, meetings, and special occasions.',
        paragraphs: [
            'Make your event memorable with our customized coffee and pastry catering services. Whether it’s a corporate meeting, wedding, or special celebration, we deliver high-quality beverages and fresh baked goods to suit your gathering.',
            'Our team works closely with you to design a menu that fits your event’s theme and preferences. From espresso drinks to an assortment of pastries, we bring the café experience to your venue.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'Tailored Coffee & Pastry Packages',
            'On-Site Barista Service Available',
            'Freshly Brewed Coffee Options',
            'Variety of Baked Goods',
            'Ideal for Corporate & Private Events'
        ],
        procedure: [
            'Initial Event Consultation',
            'Menu Customization Based on Needs',
            'Preparation & Packaging',
            'Delivery & Setup at Venue',
            'Optional Barista Service On-Site'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of events do you cater to?',
                content: 'We cater to corporate meetings, weddings, birthdays, and a variety of private and public events.'
            },
            {
                id: 2,
                heading: 'Can I customize the catering menu?',
                content: 'Yes! We offer full customization of both beverages and pastries to match your event’s theme and dietary needs.'
            },
            {
                id: 3,
                heading: 'Do you provide on-site baristas for events?',
                content: 'Yes, we offer professional on-site barista services to craft drinks fresh at your event location.'
            },
            {
                id: 4,
                heading: 'How far in advance should I book catering?',
                content: 'We recommend booking at least 1–2 weeks in advance to ensure availability and allow for proper planning.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Coffee Workshops',
        content: 'Interactive workshops where customers can learn about coffee brewing and tasting techniques.',
        paragraphs: [
            'Our coffee workshops are perfect for enthusiasts who want to dive deeper into the world of coffee. From brewing techniques to flavor profiling, our hands-on sessions are designed to be both educational and fun.',
            'Led by skilled baristas and coffee experts, these workshops cover everything from the basics of espresso making to advanced latte art. Whether you’re a beginner or a coffee aficionado, there’s something here for everyone.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Hands-On Brewing Experience',
            'Guided Coffee Tasting Sessions',
            'Introduction to Brewing Equipment',
            'Espresso & Latte Art Techniques',
            'Workshops for All Skill Levels'
        ],
        procedure: [
            'Workshop Registration & Welcome',
            'Introduction to Coffee & Brewing Basics',
            'Demonstration of Techniques',
            'Participant Practice Sessions',
            'Q&A and Certificate of Completion'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Do I need prior experience to join a workshop?',
                content: 'No prior experience is necessary! Our workshops are open to all skill levels and are beginner-friendly.'
            },
            {
                id: 2,
                heading: 'What topics do the workshops cover?',
                content: 'Workshops include topics like coffee bean origins, brewing methods, espresso making, latte art, and coffee tasting techniques.'
            },
            {
                id: 3,
                heading: 'How long does a typical workshop last?',
                content: 'Most workshops last between 1.5 to 2 hours, depending on the topic and number of participants.'
            },
            {
                id: 4,
                heading: 'Do I get to keep any materials from the workshop?',
                content: 'Yes, participants receive handouts, recipe cards, and sometimes small souvenirs or samples to take home.'
            }
        ]
    }

];

export default services;